"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _clsx = _interopRequireDefault(require("clsx"));
var _index = _interopRequireDefault(require("./index.style"));
const NavLink = props => {
  const classes = (0, _index.default)();
  const {
    children,
    component = 'button',
    underline = 'none',
    className,
    icon = /*#__PURE__*/_react.default.createElement(_ArrowBack.default, {
      fontSize: "inherit",
      viewBox: "4 4 16 16"
    }),
    ...others
  } = props;
  return /*#__PURE__*/_react.default.createElement(_core.Link, (0, _extends2.default)({
    className: (0, _clsx.default)(classes.rootNavLink, className)
  }, others, {
    component: component,
    underline: underline
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.linkIcon)
  }, icon), children));
};
var _default = exports.default = NavLink;